import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function TruthSection() {
  return <section className="py-14 bg-zinc-950 relative overflow-hidden" data-id="element-531">
      {/* Subtle background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-brand-red/50 to-transparent" data-id="element-532"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-xl h-[200px] bg-brand-red/5 rounded-full pointer-events-none" style={{
      filter: 'blur(60px)'
    }} data-id="element-533"></div>

      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-534">
        <FadeIn data-id="element-535">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-8 tracking-tight" data-id="element-536">
            LA VERDAD QUE NADIE TE DICE
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-537">
          <p className="text-2xl md:text-3xl text-zinc-300 mb-8 font-medium" data-id="element-538">
            El problema no es tu monopatín.
          </p>
          <p className="text-2xl md:text-3xl text-white font-bold mb-10" data-id="element-539">
            El problema es que no tenés un{' '}
            <span className="text-brand-red border-b-2 border-brand-red pb-1" data-id="element-540">
              sistema de diagnóstico y reparación propio
            </span>
            .
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-541">
          <div className="bg-zinc-900/80 border border-zinc-800 p-8 md:p-12 rounded-2xl relative overflow-hidden box-glow-red" data-id="element-542">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-red/10 rounded-full" style={{
            filter: 'blur(30px)'
          }} data-id="element-543"></div>

            <div className="text-7xl md:text-9xl font-heading font-bold text-brand-red mb-6 leading-none text-glow-red" data-id="element-544">
              80%
            </div>
            <p className="text-xl md:text-2xl text-white font-bold mb-6" data-id="element-545">
              de las fallas de los monopatines eléctricos son errores sistémicos
              y prevenibles.
            </p>

            <div className="space-y-4 text-lg text-zinc-400 text-left max-w-2xl mx-auto" data-id="element-546">
              <p data-id="element-547">No son fallas del hardware.</p>
              <p data-id="element-548">
                Son fallas que ocurren porque no existe una estructura de
                mantenimiento preventivo y diagnóstico rápido detrás de cada
                semana de uso.
              </p>
              <p data-id="element-549">
                Tu monopatín no te avisa que algo se está deteriorando. Te deja
                funcionar. Y después viene la falla.
              </p>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.6} className="mt-10" data-id="element-550">
          <p className="text-xl md:text-2xl text-zinc-300" data-id="element-551">
            La solución no es llevar el monopatín al service cada vez que algo
            pasa.
          </p>
          <p className="text-2xl md:text-3xl text-white font-bold mt-4" data-id="element-552">
            La solución es tener un sistema de diagnóstico y reparación que
            podés aplicar vos mismo.
          </p>
        </FadeIn>
      </div>
    </section>;
}